module.exports = __webpack_public_path__ + "fonts/AvenirLTStd-Light.1656ded9.ttf";